import { render, staticRenderFns } from "./PlantVarietyAnnuityStatusForm.vue?vue&type=template&id=190ba1c0&"
import script from "./PlantVarietyAnnuityStatusForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyAnnuityStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyAnnuityStatusForm.vue?vue&type=style&index=0&id=190ba1c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports